import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ProblematicAreasComponent } from './problematic-areas/problematic-areas.component';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { FormsModule } from '@angular/forms';
import { AdminStateService } from '@services/admin-state.service';

@Component({
  selector: 'app-summary-info',
  standalone: true,
  imports: [CommonModule, TranslateModule, ProblematicAreasComponent, ToggleSwitchModule, FormsModule],
  templateUrl: './summary-info.component.html',
  styleUrl: './summary-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SummaryInfoComponent {
  isAdmin: boolean = false;
  
  systemStatus = {
    cpuLoad: { value: 60, status: 'normal' },
    backgroundTasks: { value: 80, status: 'warning' },
    fileStorage: { value: 40, status: 'normal' },
    networkResponse: { value: 95, status: 'normal' }
  };

  constructor(private adminStateService: AdminStateService) {
    this.isAdmin = this.adminStateService.getAdminState();
  }

  onAdminToggleChange(): void {
    this.adminStateService.setAdminState(this.isAdmin);
  }
}